<div #modalContainer>
  <div [ngClass]="{'modal-blur': isPublishShow}">
    <div class="modal-header flex-column px-3 pt-3 pb-2">
      <div class="d-none d-sm-flex w-100 justify-content-between align-items-start">
        <h4 class="modal-title title-font-size" id="modal-basic-title">Image Configuration - </h4>  <h2 class="business-name ms-4 mt-3">{{currentImage?.businessName}}</h2>
        <div class="d-flex flex-column text-end ms-2 mt-4">
          <small>
            {{getImageTypeName(currentImage?.imageTypeId)}}
            ({{getImageIndexInType(currentImage)}}/{{getTotalImagesInType(currentImage)}} Images)
          </small>
        </div>
        <button type="button" class="btn-close mt-2" aria-label="Close" (click)="onCloseModal()" title="Close Modal"></button>
      </div>
      <div class="d-flex d-sm-none w-100 flex-column">
        <div class="d-flex justify-content-between align-items-start">
          <h4 class="modal-title title-font-size" id="modal-basic-title">Image Configuration</h4>
          <button type="button" class="btn-close mt-2" aria-label="Close" (click)="onCloseModal()" title="Close Modal"></button>
        </div>
        <h2 class="business-name mt-1">{{currentImage?.businessName}}</h2>
        <small class="mt-1">
          {{getImageTypeName(currentImage?.imageTypeId)}}
          ({{getImageIndexInType(currentImage)}}/{{getTotalImagesInType(currentImage)}} Images)
        </small>
      </div>
    </div>
    <div class="modal-body mt-3 d-flex flex-column" [style.max-height.px]="modalHeight" [style.min-height.px]="modalHeight">
      <div [ngbNavOutlet]="nav" class=""></div>
      <div class="d-flex justify-content-center mt-auto img-cfg-mobile-view">
        <div class="mt-2 d-flex justify-content-center img-tab-wrap">
          <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (navChange)="beforeTabChange($event)">
            <ng-container ngbNavItem="1">
              <button ngbNavLink>
                Dashboard View
              </button>
              <ng-template ngbNavContent>
                <div class="d-flex justify-content-center" *ngIf="isShow">
                  <angular-cropper #angularCropperHome [cropperOptions]="configHome" [imageUrl]="inputImg" (crop)="onDashboardViewCrop($event)">
                  </angular-cropper>
                </div>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem="2">
              <button ngbNavLink>
                Detail View
              </button>
              <ng-template ngbNavContent>
                <div class="d-flex justify-content-center" *ngIf="isShow">
                  <angular-cropper #angularCropperDetail [cropperOptions]="configDetail" [imageUrl]="inputImg" (crop)="onDetailViewCrop($event)">
                  </angular-cropper>
                </div>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem="3">
              <button ngbNavLink>
                Mobile View
              </button>
              <ng-template ngbNavContent>
                <div class="d-flex justify-content-center" *ngIf="isShow">
                  <angular-cropper #angularCropperMobile [cropperOptions]="configMobile" [imageUrl]="inputImg" (crop)="onMobileViewCrop($event)">
                  </angular-cropper>
                </div>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer d-flex justify-content-center border-top-0 pt-0">
      <button class="btn btn-primary upload-btn w-50" (click)="onSubmit(active)">{{active === '3' ? 'Confirm Image Crop' : 'Next Section'}}</button>
    </div>
    <small class="d-flex justify-content-center border-top-0 mb-2 pt-0">
      ({{getBusinessIndex(currentImage)}}/{{getTotalBusinesses()}}) Business
    </small>
  </div>
</div>

<ng-template #confirmationModal let-modal>
  <div class="modal-head">
    <!--<button class="btn btn-close" (click)="modal.dismiss('Cross click')"></button>-->
  </div>
  <div class="modal-body text-center">
    <h5 class="confirm-info-text">Is the business ready to be published?</h5>
    <div class="btn-grps">
      <button class="btn btn-outline-primary" title="No" (click)="close();modal.dismiss()">No</button>
      <button class="btn btn-primary btn-radius ms-2" (click)="modal.dismiss();publishRestaurant()" title="Yes">Yes</button>
    </div>
  </div>
</ng-template>
